module.exports = __webpack_public_path__ + "static/media/OpenSansSemiBoldItalic.396012d9.woff";